import { useCallback } from 'react'
import { useChatStore } from '@/stores/chat-store'
import { useTickerDropTarget } from '@/features/ticker-drag/use-ticker-drop-target'

/**
 * A ticker dropped anywhere on a chat surface (side panel or floating
 * window) lands in the composer as `$TICKER` at the cursor, never replacing
 * what the user already typed.
 */
export function useChatTickerDrop(enabled = true) {
  const onDrop = useCallback((ticker: string) => {
    useChatStore.getState().insertIntoComposer(`$${ticker}`)
  }, [])
  return useTickerDropTarget(onDrop, enabled)
}
